export const DEFAULT_WEIGHT_SALE_AMOUNT = 1000; // FCFA, minimum imposé

export const isWeightSaleProduct = (product) =>
  (product.category || "").trim().toLowerCase() === "produits frais" &&
  (product.sous_category || "").trim().toLowerCase() === "charcuterie";

/**
 * Construit l'objet à passer à addProductToCart pour un produit vendu au
 * poids : prix de départ = montant par défaut (1000F), pricePerKg conservé
 * pour permettre le recalcul dans le panier, weightLabel pour l'affichage.
 */
export const buildWeightSaleCartProduct = (product, amount = DEFAULT_WEIGHT_SALE_AMOUNT) => {
  const pricePerKg = Number(product.price) || 0;
  const estGrams = pricePerKg > 0 ? Math.round((amount / pricePerKg) * 1000) : 0;

  return {
    ...product,
    price: amount,
    pricePerKg,
    weightLabel: `≈ ${estGrams} g`,
  };
};
